import * as React from 'react';
import {withStyles, WithStyles} from '@material-ui/core';
import { ChatStyle } from './Chat.style';
import TranslateNew from '@translate/TranslateNew';
import { secondaryColor } from 'src/main.style';
import { ChatMsgStatus } from '@app-types/websocket/chat.types';
import { isToxicBlocked, isToxicFlagged } from '@services/chat/toxicVerdict';
import Button from '@components/common/button/Button';

const tn: TranslateNew = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof ChatStyle> {
  edit:() => void;
  copy:() => void;
  reply?:() => void; // left out where the message can't be replied to
  send:() => void;
  cancel:() => void;
  fromMe:boolean;
  sendingTime:number;
  toxicVerdict?:number;
  isSent:boolean;
  status?:ChatMsgStatus;
  isOnline:boolean;
  hasText:boolean;
  rewrite?:string;
  attachmentURL?:string;
}

interface IState {
  editable:boolean;
}

class ChatActionBar extends React.Component<IProps, IState> {
  // Create a ref to the div that will display the countdown.
  private countdownRef = React.createRef<HTMLDivElement>();
  // Variable to hold the current seconds.
  private seconds: number = 10;
  // Variable to store the interval ID.
  private intervalId?: NodeJS.Timeout;
  
  constructor(props: IProps) {
    super(props);

    const cutOffTimeForAction = props.sendingTime+120000;

    if (isToxicBlocked(this.props.toxicVerdict)) {
      this.seconds = 0;
    } else {
      this.seconds = (cutOffTimeForAction) < Date.now()?0:Math.floor(((cutOffTimeForAction) - Date.now()) / 1000);
    }
      
    this.state = {
      editable: (cutOffTimeForAction) > Date.now(),
    };
  }

  public componentDidMount() {
    // Start the countdown interval.

    if (this.seconds > 0 && !isToxicBlocked(this.props.toxicVerdict)) {
      if (this.countdownRef.current && this.seconds <= 30) {
        this.countdownRef.current.innerText = (this.seconds+1).toString();
      }
      this.intervalId = setInterval(() => {
        if (this.countdownRef.current) {
          // Directly update the text content of the div.
          if (this.seconds > 0 && this.seconds <= 30  ) {
            this.countdownRef.current.innerText = this.seconds.toString();
          } else {       
            this.countdownRef.current.innerText = "";
          }
        }
        // When countdown reaches 0, clear the interval.
        if (this.seconds === 0) {
          if (this.intervalId) clearInterval(this.intervalId);
          this.setState({editable: false});
        }
        this.seconds -= 1;
      }, 1000);
    }
  }

  public componentWillUnmount() {
    // Clear the interval if the component is unmounted.
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  public render() {

    const {classes} = this.props;
    
    let textColor = '#ccc';
    let backgroundColor = '#fff';
    let borderColor = '#ccc';
    if (isToxicFlagged(this.props.toxicVerdict) && this.state.editable) {
      textColor = '#fff';
      backgroundColor = secondaryColor;
      borderColor = secondaryColor;
    } else if(this.state.editable || !this.props.isSent || (this.props.rewrite && this.props.rewrite.length > 0)) {
      textColor = 'rgba(0, 0, 0, 0.87)';
    }

    return (
      <div className={classes.chatActionBar} style={this.props.fromMe?{right:'44px'}:{left: '44px'}}>
        {this.props.isSent && this.props.reply && <Button key={("reply")}
          className={classes.chatActionBarButton + " " + classes.chatActionBarSharedButton}
          onClick={this.props.reply}>{tn.lang.chatReply}</Button>}
        {this.props.isSent && this.props.hasText && <div className={classes.chatActionBarButton} key={("copy")}
          onClick={() => this.props.copy()}>{tn.lang.copy}</div>}
        {(this.props.attachmentURL && this.props.attachmentURL.length > 5 && this.props.isSent) 
          && <div className={classes.chatActionBarButton} key={("download")}>
            <a href={this.props.attachmentURL} className={this.props.classes.chatLink} target="_blank" rel="noopener noreferrer">
            {tn.lang.download}
          </a></div>}
        {(this.props.fromMe && !this.props.isSent && this.props.status === ChatMsgStatus.AWAIT_RESULT && this.props.isOnline) 
          && !isToxicBlocked(this.props.toxicVerdict) &&
          <div className={classes.chatActionBarButton} key={("send")}
            onClick={() => this.props.send()}>{tn.lang.send}</div>}
        {(this.props.fromMe && !this.props.isSent && this.props.status === ChatMsgStatus.AWAIT_RESULT && this.props.isOnline) 
          && <div className={classes.chatActionBarButton} key={("cancel")}
            onClick={() => this.props.cancel()}>{tn.lang.cancel}</div>}
        {(this.props.fromMe && !this.props.isSent && this.props.status === ChatMsgStatus.AWAIT_RESULT && this.props.isOnline) && 
          <div className={classes.chatActionBarButton} key={("edit")} 
            style={{color: textColor, backgroundColor, borderColor, opacity: this.props.rewrite && this.props.rewrite.length > 0?0.5:1,}}
            onClick={() => this.props.edit()}>{tn.lang.edit}<div ref={this.countdownRef} /></div>}
      </div>
    );  

  }

}


export default (withStyles(ChatStyle)(ChatActionBar));



// WEBPACK FOOTER //
// ./src/components/chat/ChatActionBar.tsx